import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import store from "./state/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <BrowserRouter>
    <Provider store={store}>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <App />
      </CookiesProvider>
    </Provider>
    </BrowserRouter>
  </>
);
